import { render, staticRenderFns } from "./CancelledView.vue?vue&type=template&id=4c804ad5&scoped=true&"
import script from "./CancelledView.vue?vue&type=script&lang=js&"
export * from "./CancelledView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c804ad5",
  null
  
)

export default component.exports